// ================= BASE URLs ===================
// export const BASE_URL = "http://192.168.29.10/gi9_laravel/public";
// export const BASE_URL_PY = "http://192.168.29.10:8000/gi-service";

export const BASE_URL = "https://api.greetindia9.com";
export const BASE_URL_PY = "https://service.greetindia9.com/gi-service";
export const BASE_URL_API = `${BASE_URL}/api`;

// =============== COMMON ========================
export const ADD_FCM_TOKEN = `${BASE_URL_API}/add-fcm-token`;
export const SAVE_FEEDBACK = `${BASE_URL_API}/save-feedback`;
export const GET_APP_LOAD_DATA = `${BASE_URL_API}/get-app-load-data`;

// =============== AUTH ==========================
export const LOGIN = `${BASE_URL_API}/signup-signin`;
export const LOGOUT = `${BASE_URL_API}/logout-user`;
export const VERIFY_OTP = `${BASE_URL_API}/verify-otp`;
export const VERIFY_TOKEN = `${BASE_URL_API}/verify-token`;
export const RESEND_OTP = `${BASE_URL_API}/resend-otp`;
export const FORGOT_SEND_RESEND_OTP = `${BASE_URL_API}/send-resend-otp`;
export const FORGOT_VERIFY_OTP = `${BASE_URL_API}/verify-otp`;

// =============== USER ==========================
export const GET_SETTINGS = `${BASE_URL_API}/get-settings`;
export const GET_USER_PROFILE = `${BASE_URL_API}/get-user-profile`;
export const UPDATE_USER_PROFILE = `${BASE_URL_API}/update-user-profile`;

// =============== TEMPLATE ======================
export const GET_TEMPLATE_CATEGORIES = `${BASE_URL_API}/templates/categories`;
export const GET_TEMPLATE_BY_CATEGORY = `${BASE_URL_API}/templates/list-by-category`;
export const GET_TEMPLATE_BY_ID = `${BASE_URL_API}/template/get`;
export const GET_TEMPLATE_BY_CATEGORY_SLUG = `${BASE_URL_API}/templates/list-by-category-slug`;
export const GET_TEMPLATE_BY_SLUG = `${BASE_URL_API}/template/get-by-slug`;

// =============== ASSETS ======================
export const GET_EMOJI_CATEGORIES = `${BASE_URL_API}/assets/emoji-categories`;
export const GET_MUSICS = `${BASE_URL_API}/assets/musics`;
export const GET_FONTS = `${BASE_URL_API}/assets/fonts`;

// =============== RAZORPAY (Invitation purchase) ========
export const CREATE_RAZORPAY_ORDER_INV = `${BASE_URL_API}/create-invitation-order`;
export const SUCCESS_RAZORPAY_ORDER_INV = `${BASE_URL_API}/razorpay-invitation-success`;
export const FAILED_RAZORPAY_ORDER_INV = `${BASE_URL_API}/razorpay-invitation-failed`;

// =============== PLAN SUBSCRIPTION (web purchase) ======
// iOS users are directed to this website to manage subscriptions.
// These endpoints mirror the mobile app's plan subscription flow.
export const GET_PLANS = `${BASE_URL_API}/get-plans`;
export const CREATE_RAZORPAY_PLAN_ORDER = `${BASE_URL_API}/create-razorpay-order`;
export const SUCCESS_RAZORPAY_PLAN_ORDER = `${BASE_URL_API}/razorpay-payment-success`;
export const FAILED_RAZORPAY_PLAN_ORDER = `${BASE_URL_API}/razorpay-payment-failed`;

// ===============  ======================
export const GENERATE_VIDEO = `${BASE_URL_API}/video/generate`;
export const GENERATE_VIDEO_STREAM = `${BASE_URL_PY}/api/generate/stream`; // BASE PYTHON URL
export const UPDATE_CII = `${BASE_URL_API}/update-created-invitation-info`;
export const GET_CII = `${BASE_URL_API}/get-inv-list-by-user`;

